angular.module('bmsApp.sm.quote')
	.controller('SMCleaningServiceSaveModalCtrl', function ($scope,
															$modalInstance,
															$q,
															$ngBootbox,
															cleaningService,
															TaxHelperSvc,
															SMCleaningServiceSvc,
															$filter,
															$timeout,
															licenseId,
															ConfigService) {


		function init() {
			if (angular.isObject(cleaningService)) {
				self.cleaningService = cleaningService;
			}
			else {
				self.cleaningService = {
					added: true // newly added
				};
			}

			var promises = {
				cleaningServices: SMCleaningServiceSvc.options({licenseId: licenseId}),
				vatRate: TaxHelperSvc.setVatRate()
					.then(function (vatRate) {
						self.cleaningService.vat_rate = vatRate;
					}),
				discountTypeOptions: SMCleaningServiceSvc.discountType.options()
			};

			$q.all(promises).then(function(responses) {
				self.options.cleaningServices = responses.cleaningServices.data.cleaning_service_options;
				self.options.discountType = responses.discountTypeOptions.data.options;
				grossUpdated();
				discountTypeUpdated();
				self.loading = false;
			});


		}

		function netUpdated() {
			angular.extend(self.cleaningService, {
				vat: TaxHelperSvc.vatFromNet(self.cleaningService.net),
				gross: TaxHelperSvc.grossFromNet(self.cleaningService.net)
			});
		}

		function grossUpdated() {
			angular.extend(self.cleaningService, {
				net: TaxHelperSvc.netFromGross(self.cleaningService.gross),
				vat: TaxHelperSvc.vatFromGross(self.cleaningService.gross)
			});
		}

		function cleanTypeUpdated() {
			if (!self.cleaningService.custom_price) {
				angular.extend(self.cleaningService, {
					net: parseFloat(self.cleaningService.cleaning_service.value)
				});

				netUpdated();
			}
		}

		function onCustomPriceChange() {
			cleanTypeUpdated();
		}

		function discountTypeUpdated() {
			var cleaningService = self.cleaningService;
			if (!angular.isObject(cleaningService.discount_type)) {
				cleaningService.discount_value = 0;
				cleaningService.discount_description = '';
			}
		}

		function cancel() {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		}

		function submit() {
			if (self.formValidator.valid()) {
				var modalResult = {
					cleaningService: self.cleaningService
				};
				$modalInstance.close(modalResult);
			}
		}

		var self = $scope.SMCleanTypeSaveCtrl = {
			formvalidatorconfig: {},
			formValidator: {},
			cleaningService: {},
			loading: true,
			processing: false,
			options: {},
			methods: {
				init: init,
				cancel: cancel,
				submit: submit,
				netUpdated: netUpdated,
				grossUpdated: grossUpdated,
				cleanTypeUpdated: cleanTypeUpdated,
				onCustomPriceChange: onCustomPriceChange,
				discountTypeUpdated: discountTypeUpdated,
				getDiscountedNet: function () {
					return SMCleaningServiceSvc.calcDiscountedNet(self.cleaningService);
				},
				getDiscountedVat: function () {
					return SMCleaningServiceSvc.calcDiscountedVat(self.cleaningService);
				},
				getDiscountedGross: function () {
					return SMCleaningServiceSvc.calcDiscountedGross(self.cleaningService);
				}
			}
		};


	});
